/**
 * Created by rafael on 10.03.17.
 */
import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import {
  DropdownButton,
  MenuItem,
  Button,
  FormGroup,
  FormControl,
  HelpBlock,
  ButtonGroup,
  ButtonToolbar,
  Tabs,
  Tab,
  Glyphicon,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../../MapHeader/MapHeader.scss';
import s1 from './SpatialAnalysis.scss';

import { clearRoute } from '../../../actions/routing.js';
import { setStartPoint } from '../../../actions/routing.js';
import { setEndPoint } from '../../../actions/routing.js';
import { postPoi } from '../../../actions/postGeoData';
import { postHotel } from '../../../actions/postGeoData';
import {
  disableMeasurementTool,
  setMeasurementTool,
  resetAddPoiTool,
  resetAddHotelTool,
  toggleAnalysis,
  changeAnalysisConfig,
  clearAnalysis,
} from '../../../actions/mapTools';

import POIModal from '../POIModal';
import AddHotelModal from '../AddHotelModal';


// const mapStateToProps = state => ({
//   layers: state.district.district.layers.map(
//     (item, index) =>
//       ({
//         ...item,
//         id: index
//       })
//   )
// });

// @connect(mapStateToProps)
class SpatialAnalysis extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedLayerOne: null,
      selectedType: null,
      selectedLayerTwo: null,
      formValue: '',
      menu: 1,
      trasa: true,
    };
  }

  setSelectedLayerOne = (eventKey) => {
    this.setState({ selectedLayerOne: eventKey });
  };
  setType = (eventKey) => {
    this.setState({ selectedType: eventKey });
  };
  setSelectedLayerTwo = (eventKey) => {
    this.setState({ selectedLayerTwo: eventKey });
  };

  getValidationState() {
    const length = this.state.formValue.length;
    if (!/^-?[\d.]+(?:e-?\d+)?$/.test(this.state.formValue)) return 'error';
    else if (length > 5) return 'warning';
    else if (length >= 1) return 'success';
  }

  handleChange(e) {
    this.setState({ formValue: e });
  }
  onClickMenu(key) {
    this.setState({ menu: key });
  };

  onClickTrasa = () => {
    if (this.props.routing.hasBothPoints) {
      this.props.clearRoute();
    } else {
      const startPoint = { lat: 50.24363713177181, lng: 23.118925094604496 };
      const endPoint = { lat: 50.239575038167956, lng: 23.161840438842777 };
      this.props.setStartPoint(startPoint);
      this.props.setEndPoint(endPoint);
    }
  };

  openModal = (typ) => {
    if (this.props.tools.currentTool) {
      this.disableTool();
    } else {
      this.props.setMeasurementTool(typ);
    }
  }

  disableTool = () => {
    this.props.disableMeasurementTool();
  }

  closePOIModal = () => this.props.resetAddPoiTool();
  closeAddHotelModal = () => this.props.resetAddHotelTool();

  onPoiSubmit = (data) => {
    let addPoint = data;
    addPoint['wsp'] = this.props.tools.map_tools.addPoi.selectedPoint;
    this.props.postPoi(this.props.district.prefix, data)
    .then(resp => {
      this.props.resetAddPoiTool();
    });
  }

  onHotelSubmit = (data) => {
    let addPoint = data;
    addPoint['wsp'] = this.props.tools.map_tools.addHotel.selectedPoint;
    this.props.postHotel(this.props.district.prefix, data)
    .then(resp => {
      this.props.resetAddHotelTool();
    });
  }

  onChangeForm = (e) => this.props.changeAnalysisConfig(e.target.name, e.target.value)

  render() {
    const layerOneItems = this.props.layers.map(
      item => <MenuItem eventKey={item.id + 1} key={item.id}>{item.name}</MenuItem>,
    );

    const typeItems = [
      'Pokrywające się',
      'Rozłączne',
      'Posiadające część wspólną',
      'Dotykające się w przestrzeni',
      'Dzielenie drugiego obiektu na dwie części',
      'Zawierające się wewnątrz siebie',
      'Całkowicie zawierające się wewnątrz siebie',
      'Nakładające się na drugi obiekt',
      'Obszar w określonej odległości od obiektu'
    ];
    const typeItemsMapped = typeItems.map(
      (item,index) => <MenuItem eventKey={index + 1} key={index}>{item}</MenuItem>
    );

    let i;
    this.state.selectedLayerOne === null ? i=1 : i=this.state.selectedLayerOne;
    const layerTwoItems = this.props.layers.filter(
      item => item.name !== this.props.layers[i-1].name
    ).map(
      item => <MenuItem eventKey={item.id + 1} key={item.id}>{item.name}</MenuItem>,
    );
    var checoutTrasa;
    this.state.trasa ? checoutTrasa={color: 'green'} : checoutTrasa={color: 'red'};
    return (
      <div className={'navPopups col-sm-3 panel panel-default absolute-popup'}>
        {this.state.menu == 1 ? <div className={'panel-heading'}>Analizy przestrzenne<img src={this.props.xbutton} alt="X Button" style={{float: "right"}} className="xbutton" onClick={this.props.onSpatialAnalysisClick}/></div> : null}
        {/*{this.state.menu == 2 ? <div className={'panel-heading'}>Wydruki</div> : null}*/}
        {this.state.menu == 3 ? <div className={'panel-heading'}>Points Of Interests<img style={{float: "right"}} src={this.props.xbutton} alt="X Button" className="xbutton" onClick={this.props.onSpatialAnalysisClick}/></div> : null}
        {this.state.menu == 4 ? <div className={'panel-heading'}>Wyznaczanie trasy<img style={{float: "right"}} src={this.props.xbutton} alt="X Button" className="xbutton" onClick={this.props.onSpatialAnalysisClick}/></div> : null}
        <Tabs activeKey={this.state.menu} onSelect={(key)=>this.onClickMenu(key)} id="uncontrolled-tab-example">
          <Tab eventKey={1} title="Analizy">
            <div className={'panel-body'}>
              <div className="row">
                <div className="col-sm-12">

                  {/* WYBÓR PIERWSZEJ WARSTWY */}
                  <div className="form-group">
                    <label htmlFor="layer_from">Warstwa pierwsza</label>
                    <select
                      name="layer_from"
                      onChange={(e) => this.onChangeForm(e)}
                      className="form-control"
                      value={this.props.tools.spatial_analysis.layer_from ? this.props.tools.spatial_analysis.layer_from : ''}
                    >
                      {this.props.district.layers.map((v, i) => {
                        return <option key={i} value={v.name}> {String.prototype.normalizeLayerName(v.name)}</option>;
                      })}
                    </select>
                  </div>

                  {/*WYBÓR FUNKCJI ZAPYTANIA PRZESTRZENNEGO*/}
                    <div className="form-group">
                      <label htmlFor="queryFunction">Typ zapytania przestrzennego</label>
                      <select
                        name="queryFunction"
                        onChange={(e) => this.onChangeForm(e)}
                        className="form-control"
                        disabled={!this.props.tools.spatial_analysis.layer_from}
                        value={this.props.tools.spatial_analysis.queryFunction ? this.props.tools.spatial_analysis.queryFunction : ''}
                      >
                        {typeItems.map((v, i) => {
                          return <option key={i} value={v}>{v}</option>;
                        })}
                      </select>
                    </div>

                  {this.props.tools.spatial_analysis.queryFunction && this.props.tools.spatial_analysis.queryFunction ==='BUFFER' ?
                    (
                      <div className="form-group">
                        <label htmlFor="bufor_size">Rozmiar bufora (w metrach)</label>
                        <input
                          type="text"
                          name="bufor_size"
                          onChange={(e) => this.onChangeForm(e)}
                          className="form-control"
                          value={this.props.tools.spatial_analysis.bufor_size ? this.props.tools.spatial_analysis.bufor_size : ''}
                        />
                      </div>)
                  : null}

                  {/* WYBÓR DRUGIEJ WARSTWY */}
                  <div className="form-group">
                    <label htmlFor="layer_to">Warstwa druga</label>
                    <select
                      name="layer_to"
                      onChange={(e) => this.onChangeForm(e)}
                      className="form-control"
                      disabled={!this.props.tools.spatial_analysis.queryFunction}
                      value={this.props.tools.spatial_analysis.layer_to ? this.props.tools.spatial_analysis.layer_to : ''}
                    >
                      {this.props.district.layers.map((v, i) => {
                        return <option key={i} value={v.name}> {String.prototype.normalizeLayerName(v.name)}</option>;
                      })}
                    </select>
                  </div>

                  {this.props.tools.spatial_analysis.queryFunction ?
                    <button className="btn btn-primary" onClick={() => this.props.toggleAnalysis()}>Zastosuj</button> : null
                  }
                  {this.props.tools.spatial_analysis.isEnabled ?
                    <Button className="btn btn-warning" onClick={() => this.props.clearAnalysis()}>Wyczyść</Button> : null
                  }
                </div>
              </div>
            </div>
          </Tab>
          {/*<Tab eventKey={2} title="Wydruki">Tab 2 content</Tab>*/}
          <Tab eventKey={3} title="POI">{/*<div className={'panel-heading'}>Points Of Interests</div>*/}
            <div className={'panel-body'}>
              <ButtonGroup justified>
                <Button href="#" onClick={() => this.openModal('addPoi')} className={this.props.tools.currentTool ==='addPoi' ? 'btn btn-primary' : 'btn btn-default'}>Zgłoś POI</Button>
                <Button href="#">Edytuj POI</Button>
              </ButtonGroup>
              <hr />
              <ButtonGroup justified>
                <Button href="#" onClick={() => this.openModal('addHotel')} className={this.props.tools.currentTool ==='addHotel' ? 'btn btn-primary' : 'btn btn-default'}>Zgłoś hotel</Button>
                <Button href="#">Edytuj hotele</Button>
              </ButtonGroup>
              <hr />
              <ButtonGroup justified>
                <Button href="#">Dodawanie obiektów</Button>
                <DropdownButton
                  title={this.state.selectedLayerOne ? this.props.layers[this.state.selectedLayerOne - 1].name : ''}
                  key={0}
                  id="bg-justified-dropdown"
                  onSelect={(eventKey) => this.setSelectedLayerOne(eventKey)}
                >
                {layerOneItems}
                </DropdownButton>
              </ButtonGroup>
              <ButtonGroup justified style={{marginTop: "15px"}}>
                <Button href="#">Edycja obiektu</Button>
                <DropdownButton
                  title={this.state.selectedLayerTwo ? this.props.layers[this.state.selectedLayerTwo - 1].name : ''}
                  id="bg-justified-dropdown"
                >
                </DropdownButton>
              </ButtonGroup>
            </div>
            <POIModal
              onPoiSubmit={this.onPoiSubmit}
              showModal={this.props.tools.map_tools.addPoi.selectedPoint === null ? false : true }
              onClose={this.closePOIModal}
            />
            <AddHotelModal
              onHotelSubmit={this.onHotelSubmit}
              showModal={this.props.tools.map_tools.addHotel.selectedPoint === null ? false : true }
              onClose={this.closeAddHotelModal}
            />
          </Tab>
          <Tab eventKey={4} title="Trasa">
            <div className={'panel-body'} style={{textAlign: "center"}}>
              <div className={'panel-heading'}>Funkcja wyznaczania trasy jest:</div>
                {this.props.routing.hasBothPoints ? <span style={{color: 'green'}} className="checkoutIcon glyphicon glyphicon-ok-sign"><br/><a style={{fontSize: '20px', color: 'green'}}>Aktywna</a></span> :
                  <span style={{color: 'red'}} className="checkoutIcon glyphicon glyphicon-remove-sign"><br/><a style={{fontSize: '20px', color: 'red'}}>Nieaktywna</a></span>}<hr/>
              <ButtonGroup>
                 {this.props.routing.hasBothPoints ? <Button onClick={this.onClickTrasa} href="#">Dezaktywuj</Button> :
                 <Button onClick={this.onClickTrasa} href="#">Aktywuj</Button>}
              </ButtonGroup><br/>
            </div>
          </Tab>
        </Tabs>
      </div>
    );
  }
}

SpatialAnalysis.PropTypes = {
  openPOIModal: React.PropTypes.func.isRequired,
};

const mapState = (state) => ({
  district: state.district.district,
  tools: state.tools,
  routing: state.routing,
  layers: state.district.district.layers.map(
    (item, index) =>
      ({
        ...item,
        id: index,
      }),
  ),
});

const mapDispatch = {
  disableMeasurementTool,
  setMeasurementTool,
  setStartPoint,
  setEndPoint,
  clearRoute,
  resetAddPoiTool,
  resetAddHotelTool,
  postPoi,
  postHotel,
  toggleAnalysis,
  changeAnalysisConfig,
  clearAnalysis,
};

export default withStyles(s,s1)(connect(mapState, mapDispatch)(SpatialAnalysis));

//this.state.selectedLayerOne ? this.props.layers[this.state.selectedLayerOne - 1].name : null



// WEBPACK FOOTER //
// src/components/Modals/SpatialAnalysis/SpatialAnalysis.js